/* eslint-disable complexity */
import { i18n } from 'next-i18next'
import { Offer } from '../models'

const leftLang = { en: 'left', es: 'restante', fr: 'restant', ko: '왼쪽', de: 'links', pt: 'subtração', it: 'residuo', pl: 'pozostały' }
const expiredLang = { en: 'Expired', es: 'Caducada', fr: 'Expiré', ko: '만료', de: 'Abgelaufen', pt: 'Expirado', it: 'è scaduto', pl: 'wygasły' }
const acceptedLang = { en: 'Accepted', es: 'Aceptada', fr: 'Accepté', ko: '수락', de: 'Akzeptiert', pt: 'Aceitaram', it: 'Accettato', pl: 'przyjęty' }
const cancelLang = { en: 'Cancelled', es: 'Cancelada', fr: 'Annulé', ko: '취소 된', de: 'Abgebrochen', pt: 'Cancelada', it: 'Annullato', pl: 'Odwołany' }

export const getOfferStatus  = (offer: Offer, expireOffer: Function): string => {
  if (offer.state === 'expired') {
    return expiredLang[i18n.language] || 'expired'
  } else if (offer.state === 'accepted') {
    return acceptedLang[i18n.language] || 'accepted'
  } else if (offer.state === 'cancelled') {
    return cancelLang[i18n.language] || 'cancelled'
  }
  const date = new Date()
  const dateOffer = new Date(offer.date)
  dateOffer.setHours(dateOffer.getHours() + offer.expiration_value)
  let hours = (date.getTime() - dateOffer.getTime()) / 3600000
  if (hours >= 0 && offer.state !== 'expired') {
    expireOffer(offer)
    return expiredLang[i18n.language] || 'expired'
  }
  hours = Math.abs(hours)
  let days = 0
  while (hours >= 24) {
    days += 1
    hours -= 24
  }
  const finalMinutes = (parseFloat('0.' + (hours + '').split('.')[1])) * 60
  let finalDays = ''
  if (days >= 1) {
    finalDays = days + 'd '
  }
  return finalDays + Math.trunc(hours) + 'h ' + Math.trunc(finalMinutes) + 'm ' + leftLang[i18n.language] || 'left'
}
